const state = {
    status: false
};

export default {
    namespaced: true,
    state,
};
